import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Modal } from 'semantic-ui-react';
import { saleSetRegisterApi } from '../../../../api/sf_saleset_register';
import { DefaultButton, PrimaryButton } from "../../../../components/editor/button";
import ComboboxSaleSetRegisterType from '../../../../components/editor/cmb_saleset_register_type';
import { InValidMessage } from '../../../../components/editor/invalid_message';
import { FormGroup } from '../../../../components/form-group';
import { useCommonContext } from '../../../../contexts/common';
import { showNotify } from '../../../../helpers/toast';
import styles from '../detail-modal/DangKyDichVuDetailMoal.module.css'
const DangKyDichVuDetailModal = ({ sf_saleset_register, onCancel, onSuccess  }) => {
    const [formData, setformData] = useState({});
    const [isSaving, setisSaving] = useState(false);
    const { register, trigger, errors } = useForm();
    const { translate } = useCommonContext();

    const handleSaveChanges = async () => {
        trigger().then(async (isValid) => {
            if (isValid) {
                let res;
                setisSaving(true);
                if (formData.id > 0) {
                    res = await saleSetRegisterApi.Update(formData);
                } else {
                    res = await saleSetRegisterApi.Insert(formData);
                }
                setisSaving(false);
                if (res.is_success) {
                    showNotify({ type: "success", text: formData.id > 0 ? translate('Cập nhật thành công.') : translate('Đăng ký thành công.') });
                    onSuccess();
                } else {
                    showNotify({ type: "error", text: "Có lỗi xảy ra" });
                }
            }
        })
    }

    useEffect(()=>{
        if(sf_saleset_register){
            setformData({...sf_saleset_register})
        }
    }, [sf_saleset_register]);

  return (
   <>
        <Modal className= {styles.modal_center} open={true} size="mini" dimmer={"blurring"} onClose={onCancel}
                closeOnEscape={false}
                closeOnDimmerClick={false}
                >
                <Modal.Header>
                    {formData.id > 0 ? <p>{translate('Cập nhật')}</p> : <p>{translate('Thêm mới')}</p>}
                </Modal.Header>
                <Modal.Content>
                    <form className="ui">
                        <div className='row'>
                            <div className='col-md-12'>
                                <FormGroup label={translate('Loại đăng ký')}>
                                    <ComboboxSaleSetRegisterType value={formData.sf_saleset_register_type_id}
                                        width="100%"
                                        onValueChanged={(value) => {
                                            setformData({ ...formData, sf_saleset_register_type_id: value });
                                            trigger("nam_hoc")
                                        }} />
                                    <InValidMessage errors={errors} register={register({ required: true, min: 1 })}
                                            defaultValue={formData.sf_saleset_register_type_id}
                                            message={translate('Vui lòng chọn Loại đăng ký.')}
                                            name={"sf_saleset_register_type_id"}
                                        />
                                </FormGroup>
                            </div>
                        </div>
                    </form>
                </Modal.Content>
                <Modal.Actions>

                    <div>
                        <DefaultButton text={"Đóng"} onClick={onCancel} />
                        <PrimaryButton
                            text={sf_saleset_register?.id > 0 ? translate('Cập nhật') : translate('Đăng ký mới')}
                            onClick={handleSaveChanges}
                            isLoading={isSaving}
                        />


                    </div>
                </Modal.Actions>
            </Modal>
   </>
  )
}

export default DangKyDichVuDetailModal